import { useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Context } from "../Context";
import { IoSettingsOutline } from "react-icons/io5";
import { CgProfile } from "react-icons/cg";
import { IoLogOutOutline } from "react-icons/io5";
import { FaDiscord } from "react-icons/fa";
import { login, logout } from "../auth";

export default function Navbar() {
  const context = useContext(Context);
  const discordBotInviteURL = context.urls.discordBotInviteURL;
  const fishcordServerInviteURL = context.urls.fishcordServerInviteURL;
  const user = context.user;
  
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Tracking the mouse to determine when to stop displaying the menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  // When the logo image in the navbar is clicked it will scroll the window to the top of the screen
  function fishcordLogoOnClick() {
    if (location.pathname === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({ top: 0 });
      navigate("/");
    }
  }

  // Will scroll to the features section if on homepage, otherwise will redirect to home
  function featuresOnClick() {
    if (location.pathname === "/") {
      document
        .getElementById("features")
        .scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollToFeatures: true } });
    }
  }

  // Will scroll to commands section if on homepage, otherwise will redirect to home
  function commandsOnClick() {
    if (location.pathname === "/") {
      document
        .getElementById("commands")
        .scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollToCommands: true } });
    }
  }

  function profileOnClick() {
    setIsMenuOpen(!isMenuOpen);
  }

  const loginButton = (
    <button
      className="flex flex-row ml-4 justify-center items-center text-xs sm:text-base md:text-xl text-black px-3 py-2 border border-black rounded-lg hover:rounded-none hover:bg-secondaryColor duration-200"
      onClick={login}
    >
      <label>Login with</label>
      <FaDiscord size="1.2em" className="ml-1" />
    </button>
  );

  const menu = user && (
    <div
      ref={menuRef}
      className="absolute right-0 top-16 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-50"
    >
      <h3 className="text-lg pl-4 py-2">{user.global_name}</h3>
      <ul className="py-1 border-t border-dimWhite">
        <li
          className="flex items-center text-lg px-4 py-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => navigate("/user/profile")}
        >
          <CgProfile className="mr-2" /> Profile
        </li>
        <li
          className="flex items-center text-lg px-4 py-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => navigate("/settings")}
        >
          <IoSettingsOutline className="mr-2" />
          Settings
        </li>
        <li
          className="flex items-center text-lg px-4 py-2 hover:bg-gray-100 cursor-pointer"
          onClick={logout}
        >
          <IoLogOutOutline className="mr-2" /> Logout
        </li>
      </ul>
    </div>
  );

  return (
    <nav
      className="flex justify-center sticky top-0 z-50 items-center border-b bg-primaryColor"
      style={{ borderColor: "rgba(182, 182, 182, 0.5)" }}
    >
      <div className="flex flex-row justify-between w-4/5 pt-3 pb-3">
        <div className="flex flex-row navbar--headers">
          <ul className="flex flex-row items-center text-xl">
            <img
              className="w-14 h-auto object-contain mr-4 cursor-pointer -scale-x-100"
              src={require("../images/fishcord-logo-nbg.png")}
              alt="Fishcord Logo"
              onClick={fishcordLogoOnClick}
            />
            <li className="hidden md:block mr-4 cursor-pointer underline-hover-animation">
              <button onClick={featuresOnClick}>Features</button>
            </li>
            <li className="hidden md:block mr-4 cursor-pointer underline-hover-animation">
              <button onClick={commandsOnClick}>Commands</button>
            </li>
            <li className="hidden md:block">
              <a
                className="underline-hover-animation"
                href={fishcordServerInviteURL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Join our Discord
              </a>
            </li>
          </ul>
        </div>

        <div className="flex flex-row items-center">
          <a href={discordBotInviteURL} target="_blank" rel="noreferrer">
            <button className="text-xs sm:text-base md:text-lg lg:text-xl text-black px-3 py-2 border border-black rounded-lg hover:rounded-none hover:bg-secondaryColor duration-200">
              Add to Server
            </button>
          </a>

          <div className="relative flex flex-col items-center">
            {user ? (
              <img
                className="rounded-full border border-black w-12 ml-4 cursor-pointer hover:scale-105 duration-100"
                src={
                  user.avatar
                    ? user.avatar
                    : require("../images/discord_default_pfp.png")
                }
                onClick={profileOnClick}
                alt="User Avatar"
              />
            ) : (
              loginButton
            )}

            {isMenuOpen && menu}
          </div>
        </div>
      </div>
    </nav>
  );
}
